import React from 'react';
import PropTypes from 'prop-types';
import styled, { ThemeContext } from 'styled-components';
import { useChangeAwareEffect } from 'use-change-aware-effect';
import { SectionContainer } from '../../shared/sectionable/styles';
import Title from './fund-updates-components/title';
import Details from './fund-updates-components/details';
import Follow from './fund-updates-components/follow';
import { scrollIfHashMatch } from '../../shared/navigation/utils';

const Container = styled(SectionContainer)`
  margin-bottom: 104px;

${props => !props.theme.isMobile && `
    margin-top: 64px;
  `};
`;

const sectionName = 'fund-updates';

export default function FundUpdates({ fund }) {
  const { isMobile } = React.useContext(ThemeContext);

  useChangeAwareEffect(({ isMount }) => {
    isMount && scrollIfHashMatch(sectionName);
  }, {});

  return (
    <Container name={sectionName}>
      <Title fund={fund} />
      <Details fund={fund} />
      {!!isMobile && <Follow fund={fund} />}
    </Container>
  );
}

FundUpdates.propTypes = {
  fund: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    isFollowedByCurrentUser: PropTypes.bool.isRequired,
    monthlyUpdateFileUrl: PropTypes.string.isRequired,
  }).isRequired,
};
